var map = {
	"./backup/de-DE.json": "678f",
	"./backup/en-GB.json": "e509",
	"./backup/en-US.json": "071b",
	"./backup/es-ES.json": "6809",
	"./backup/fr-FR.json": "adb2",
	"./backup/it-IT.json": "6088",
	"./backup/nl-NL.json": "57f5",
	"./backup/pt-PT.json": "ce1c",
	"./de-DE.json": "6922",
	"./en-GB.json": "282d",
	"./en-US.json": "e0e1",
	"./es-ES.json": "4109",
	"./fr-FR.json": "cfe4",
	"./it-IT.json": "bf7d",
	"./nl-NL.json": "0727",
	"./pt-PT.json": "7b75"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "49f8";